import { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import "./category.css";
import { BiSolidCategory } from "react-icons/bi";
import CustomCarouselSliders from "../../components/customslider/customslider";
import { getLimitedImages } from "../../config/pageDetails";

import { useNavigate } from "react-router-dom";

const CustomSlider = ({ slide }) => {
  const images = getLimitedImages(slide?.imageUrl, "category", "cardImageLimit");

  return (
    <div>
      <CustomCarouselSliders>
        {images.map((image, index) => {
          return (
            <img
              className="image-category-slider"
              key={index}
              src={image}
              alt={slide.name}
            />
          );
        })}
      </CustomCarouselSliders>
    </div>
  );
};

const CategoryPage = () => {
  const navigate = useNavigate();
  const { t } = useContext(LanguageContext);

  const [slides, setSlides] = useState([]);

  useEffect(() => {
    fetch("/api/categories?offset=0")
      .then((response) => response.json())
      .then((data) => {
        setSlides(data.categories);
      })
      .catch((error) => console.error("Error fetching slides:", error));
  }, []);

  const handleMenuClick = (slide) => {
    const route = slide.name.toLowerCase().replace(/\s+/g, "");
    navigate(route === "home" ? "/" : `/subcategory`, { state: { slide } });
  };

  return (
    <div className="category-container">
      <div className="category-header">
        <BiSolidCategory className="category-icon" />
        <h2 className="category-header-title">
          {t(`category.productCategory`)}
        </h2>
      </div>
      <div className="category-grid">
        {slides &&
          slides.map((slide, index) => (
            <div className="category-card" key={index}>
              <CustomSlider slide={slide} />
              <div className="card-body">
                <div className="card-title">{slide.name}</div>
                <div className="card-description">{slide.description}</div>
                <button
                  className="card-button"
                  onClick={() => handleMenuClick(slide)}
                >
                  {t(`category.viewAll`)}
                </button>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default CategoryPage;
